/** size — размер шифротекста файла в байтах */
export class CreateUploadParams {
  size: number

  constructor({ size }: { size: number }) {
    this.size = size
  }
}
